import React, { useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Box } from "@mui/system";
import { formatCurrency, formatDateWithTime } from "../../utils/Utils";
// import response from "../../../utils/response.json";
import { uatResponse } from "../../utils/data";
import "./base.styles.css";
import Theme from "../../utils/Theme";
import AppButton from "./AppButton.component";
import { QRPageStyle, apitable } from "../../utils/Styles.utils";
import { useReactToPrint } from "react-to-print";
import PolicyTable from "../../utils/policyTable";
import PolicyResponse from "../../utils/policyResponse";
import moment from "moment";

const ApiTableComponent = ({ payload }) => {
  console.log("apiPayload", payload);
  let customerDetails;
  let autoPolicy = [];
  let homeOwnerPolicy = [];
  let umbrellaPolicy = [];
  let boatPolicy = [];
  let trailerPolicy = [];
  let motorcyclePolicy = [];
  let boats = [];
  //let vehicles = [];
  let trailers = [];
  let motorcycles = [];
  let dwellings = [];
  let premiumCents = 0;
  let agentAddress;
  let totalPremium = 0;
  let sumOfPremiumCents = 0;
  let monthsDifference = 1;
  let centsToDollar;

  const printRef = useRef();

  if (payload) {
    customerDetails = {
      fullName: payload.first_name + " " + payload.last_name,
      email: payload.account_email,
      homePhone: payload.home_phone || "N/A",
      mobilePhone: payload.mobile_phone || "N/A",
      workPhone: payload.work_phone || "N/A",
      driversFullName: "driver",
      //  payload.drivers.first_name + " " + payload.drivers.last_name,
      pullId: payload.pull_id,
    };
    let getAddress = payload.addresses;

    payload?.addresses?.map((address) => {
      if (address.address_nature === "PHYSICAL") {
        customerDetails.physicalAddress = address.full_address;
      } else if (address.address_nature === "MAILING") {
        customerDetails.mailingAddress = address.full_address;
      } else if (address.address_nature === "GARAGE") {
        customerDetails.garageAddress = address.full_address;
      } else if (
        payload?.agents &&
        address.address_id === payload?.agents[0]?.address_id
      ) {
        agentAddress = address.full_address;
      }
    });

    payload?.policies?.map((policy) => {
      console.log("palll", policy);
      // premiumCents += policy.total_premium_cents;
      if (policy.total_premium_cents) {
        totalPremium = totalPremium + policy.total_premium_cents;
        console.log("total_premium_cents", policy.total_premium_cents);
      }
      console.log("totalPremium", totalPremium);

      if (policy?.total_premium_cents) {
        console.log("policy?.effective_date", policy?.effective_date);
        console.log("policy?.expiry_date", policy?.expiry_date);
        if (policy?.effective_date === null || policy?.expiry_date === null) {
          monthsDifference = 12;
        } else {
          const effectiveDate = moment(policy?.effective_date);
          const expiryDate = moment(policy?.expiry_date);
          console.log("effectiveDate", effectiveDate);
          console.log("expiryDate", expiryDate);

          monthsDifference = expiryDate.diff(effectiveDate, "months");
          console.log("monthsDifferenceElse", monthsDifference);
        }
        console.log("monthsDifference", monthsDifference);
        if (monthsDifference === 12) {
          sumOfPremiumCents = sumOfPremiumCents + policy?.total_premium_cents;
          console.log("ifPart", sumOfPremiumCents);
        } else {
          sumOfPremiumCents =
            policy?.total_premium_cents * (12 / monthsDifference) +
            sumOfPremiumCents;
          console.log(`Equivalent premium for 12 months: ${sumOfPremiumCents}`);
        }
        centsToDollar = Math.round(sumOfPremiumCents / 100);
      }

      if (policy.policy_type === "AUTO") {
        let vehicles = [];
        policy.vehicles.map((vehicle) => {
          let newVehicle = {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            vin: vehicle.vin,
            coverage: vehicle.coverages,
          };
          vehicles.push(newVehicle);
        });
        let auto = {
          policyNumber: policy.carrier_policy_number,
          premium: formatCurrency(policy.total_premium_cents),
          effectiveDates: policy.description.substr(
            policy.description.indexOf(" ") + 1
          ),
          name: policy.policy_type,
          vehicles: vehicles,
          status: policy?.status,
          canceled_date: policy?.canceled_date,
        };
        autoPolicy.push(auto);
      } else if (policy.policy_type === "HOMEOWNERS") {
        policy.dwellings.map((dwelling) => {
          let newDwelling = {
            addresses: dwelling.address,
            coverages: dwelling.coverages,
          };
          dwellings.push(newDwelling);
        });
        let home = {
          ownerNumber: policy.carrier_policy_number,
          premium: formatCurrency(policy.total_premium_cents),
          effectiveDates: policy.description.substr(
            policy.description.indexOf(" ") + 1
          ),
          name: policy.policy_type,
          dwellings: dwellings,
          status: policy?.status,
          canceled_date: policy?.canceled_date,
        };
        homeOwnerPolicy.push(home);
        console.log("homeowners", homeOwnerPolicy);
      } else if (policy.policy_type === "UMBRELLA") {
        let umbrella = {
          number: policy.carrier_policy_number,
          premium: formatCurrency(policy.total_premium_cents),
          effectiveDates: policy.description.substr(
            policy.description.indexOf(" ") + 1
          ),
          name: policy.policy_type,
          status: policy?.status,
          canceled_date: policy?.canceled_date,
        };
        umbrellaPolicy.push(umbrella);
      } else if (policy.policy_type === "BOAT") {
        policy.vehicles.map((boat) => {
          let newBoat = {
            year: boat.year,
            make: boat.make,
            model: boat.model,
            vin: boat.vin,
            coverage: boat.coverages,
          };
          boats.push(newBoat);
        });

        let boat = {
          number: policy.carrier_policy_number,
          premium: formatCurrency(policy.total_premium_cents),
          effectiveDates: policy.description.substr(
            policy.description.indexOf(" ") + 1
          ),
          name: policy.policy_type,
          boats: boats,
          status: policy?.status,
          canceled_date: policy?.canceled_date,
        };
        boatPolicy.push(boat);
      } else if (policy.policy_type === "TRAILER") {
        policy.vehicles.map((vehicle) => {
          let newVehicle = {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            vin: vehicle.vin,
            coverage: vehicle.coverages,
          };
          trailers.push(newVehicle);
        });
        let trailer = {
          policyNumber: policy.carrier_policy_number,
          premium: formatCurrency(policy.total_premium_cents),
          effectiveDates: policy.description.substr(
            policy.description.indexOf(" ") + 1
          ),
          name: policy.policy_type,
          trailers: trailers,
          status: policy?.status,
          canceled_date: policy?.canceled_date,
        };
        trailerPolicy.push(trailer);
      } else if (policy.policy_type === "MOTORCYCLE") {
        policy.vehicles.map((vehicle) => {
          let newVehicle = {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            vin: vehicle.vin,
            coverage: vehicle.coverages,
          };
          motorcycles.push(newVehicle);
        });
        let motorcycle = {
          policyNumber: policy.carrier_policy_number,
          premium: formatCurrency(policy.total_premium_cents),
          effectiveDates: policy.description.substr(
            policy.description.indexOf(" ") + 1
          ),
          name: policy.policy_type,
          motorcycles: motorcycles,
          status: policy?.status,
          canceled_date: policy?.canceled_date,
        };
        motorcyclePolicy.push(motorcycle);
      }
    });
  }

  let handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: apitable,
  });
  return (
    <>
      {customerDetails && (
        <>
          <Box
            ref={printRef}
            sx={{
              // display: { xs: "contents", sm: "flex" },
              justifyContent: "center",
              width: "100%",
              height: "100%",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box>
              <Table className="border">
                <TableHead>
                  <TableRow
                    className="bg-table-head"
                    sx={{ backgroundColor: "#f2f2f2" }}
                  >
                    <TableCell className="font-bold p-6 w-50" colSpan={3}>
                      Contact
                    </TableCell>

                    <TableCell className="font-bold p-6" colSpan={3}>
                      Address
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className="p-6"> Name</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.fullName}
                    </TableCell>
                    <TableCell className="p-6">Physical</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.physicalAddress}
                    </TableCell>
                  </TableRow>
                  <TableRow
                    className="bg-table-row"
                    sx={{ backgroundColor: "#ffffff" }}
                  >
                    <TableCell className="p-6"> Email</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.email}
                    </TableCell>
                    <TableCell className="p-6">Mailing</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.mailingAddress}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="p-6"> Home Phone</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.homePhone}
                    </TableCell>
                    <TableCell className="p-6">Garage</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.garageAddress}
                    </TableCell>
                  </TableRow>
                  <TableRow
                    className="bg-table-row"
                    sx={{ backgroundColor: "#ffffff" }}
                  >
                    <TableCell className="p-6"> Mobile Phone</TableCell>
                    <TableCell className="p-6" colSpan={5}>
                      {customerDetails.mobilePhone}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="p-6"> Work Phone</TableCell>
                    <TableCell className="p-6" colSpan={5}>
                      {customerDetails.workPhone}
                    </TableCell>
                  </TableRow>
                  <TableRow
                    className="bg-table-row"
                    sx={{ backgroundColor: "#ffffff" }}
                  >
                    <TableCell className="p-6">Pull ID</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {customerDetails.pullId}
                    </TableCell>
                    <TableCell className="p-6">Total of all Premiums</TableCell>
                    <TableCell className="p-6" colSpan={2}>
                      {/* $ {formatCurrency(premiumCents)} */}$ {centsToDollar}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>

            {/* Agent Table */}
            {payload?.agents?.length > 0 && (
              <>
                <br />
                <Box>
                  <Table className="border">
                    <TableHead>
                      <TableRow
                        className="bg-table-head"
                        sx={{ backgroundColor: "#f2f2f2" }}
                      >
                        <TableCell className="font-bold p-6">
                          Agent Name
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Agency Name
                        </TableCell>
                        <TableCell className="font-bold p-6">Address</TableCell>
                        <TableCell className="font-bold p-6"></TableCell>
                        <TableCell className="font-bold p-6">Email</TableCell>
                        <TableCell className="font-bold p-6">
                          Phone Number
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payload.agents.map((agent) => {
                        return (
                          <TableRow>
                            <TableCell className="p-6">
                              {agent.agent_full_name}
                            </TableCell>
                            <TableCell className="p-6">
                              {agent.agency_name}
                            </TableCell>
                            <TableCell className="p-6">
                              {" "}
                              {agentAddress}
                            </TableCell>
                            <TableCell className="p-6">
                              {/* {agent.agent_info_id} */}
                            </TableCell>
                            <TableCell className="p-6">{agent.email}</TableCell>
                            <TableCell className="p-6">
                              {agent.phone_number}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
              </>
            )}

            {/* Driver Table */}

            {payload.drivers.length > 0 && (
              <>
                <br />
                <Box>
                  <Table className="border">
                    <TableHead>
                      <TableRow
                        className="bg-table-head"
                        sx={{ backgroundColor: "#f2f2f2" }}
                      >
                        <TableCell className="font-bold p-6">Drivers</TableCell>
                        <TableCell className="font-bold p-6">DOB</TableCell>
                        <TableCell className="font-bold p-6">Age</TableCell>
                        <TableCell className="font-bold p-6">
                          DL Number
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Relationship
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Martial status
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payload.drivers.map((driver) => {
                        return (
                          <TableRow>
                            <TableCell className="p-6">
                              {driver.first_name + " " + driver.last_name}
                            </TableCell>
                            <TableCell className="p-6">
                              {driver.date_of_birth_str}
                            </TableCell>
                            <TableCell className="p-6">{driver.age}</TableCell>
                            <TableCell className="p-6">
                              {driver.drivers_license}
                            </TableCell>
                            <TableCell className="p-6">
                              {driver.relationship_to_insured}
                            </TableCell>
                            <TableCell className="p-6">
                              {driver.marital_status}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
              </>
            )}

            {/* Auto policy table */}
            {payload?.policies?.map((policy) => {
              return <PolicyResponse policy={policy} />;
            })}

            {/* {autoPolicy.length > 0 &&
              autoPolicy.map((auto) => {
                return (
                  <>
                    <br />
                    <PolicyTable
                      name={auto?.name}
                      policyNumber={auto.policyNumber}
                      premium={auto?.premium}
                      effectiveDates={auto?.effectiveDates}
                      status={auto?.status}
                      canceled_date={auto?.canceled_date}
                      vehicles={auto?.vehicles}
                    />
                  </>
                );
              })} */}

            {/* Boat Table */}
            {/* {boatPolicy.length > 0 &&
              boatPolicy.map((boat) => {
                return (
                  <>
                    <br />
                    <PolicyTable
                      name={boat?.name}
                      policyNumber={boat?.number}
                      premium={boat?.premium}
                      effectiveDates={boat?.effectiveDates}
                      vehicles={boat?.boats}
                      status={boat?.status}
                      canceled_date={boat?.canceled_date}
                    />
                  </>
                );
              })} */}

            {/* Trailer Table  */}
            {/* {trailerPolicy.length > 0 &&
              trailerPolicy.map((trailer) => {
                return (
                  <>
                    <br />
                    <Box>
                      <Table className="border">
                        <TableHead>
                          <TableRow
                            className="bg-table-head"
                            sx={{ backgroundColor: "#f2f2f2" }}
                          >
                            <TableCell className="font-bold p-6">
                              Policies
                            </TableCell>
                            <TableCell className="font-bold p-6">
                              Number
                            </TableCell>
                            <TableCell className="font-bold p-6">
                              Premium
                            </TableCell>
                            <TableCell className="font-bold p-6" colSpan={2}>
                              Effective Dates
                            </TableCell>
                            <TableCell className="font-bold p-6">
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell className="p-6">
                              {trailer.name}
                            </TableCell>
                            <TableCell className="p-6">
                              {trailer.policyNumber}
                            </TableCell>
                            <TableCell className="p-6">
                              $ {trailer.premium}
                            </TableCell>
                            <TableCell className="p-6" colSpan={2}>
                              {trailer.effectiveDates}
                            </TableCell>
                            <TableCell
                              className="p-6"
                              sx={{
                                color:
                                  trailer?.canceled_date != null ||
                                  trailer?.status === "CANCELED"
                                    ? Theme.palette.error.main
                                    : trailer?.status === "ACTIVE"
                                    ? Theme.palette.primary.main
                                    : Theme.palette.error.main,
                                fontWeight: "bold",
                              }}
                            >
                              {trailer?.status === "CANCELLED" &&
                              trailer?.canceled_date != null
                                ? ` ${trailer?.status} - ${trailer?.canceled_date}`
                                : trailer?.status === "CANCELLED"
                                ? trailer?.status
                                : trailer?.status}
                            </TableCell>
                          </TableRow>
                          {trailer.trailers.map((trailer) => {
                            return (
                              <>
                                <TableRow>
                                  <TableCell className="p-6" colSpan={6}>
                                    {trailer.year +
                                      " " +
                                      trailer.make +
                                      " " +
                                      trailer.model}
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  className="bg-table-row"
                                  sx={{ backgroundColor: "#ffffff" }}
                                >
                                  <TableCell className="p-6" colSpan={6}>
                                    {trailer.vin}
                                  </TableCell>
                                </TableRow>
                                {trailer.coverage.length > 0 && (
                                  <>
                                    <TableRow>
                                      <TableCell className="font-bold p-6">
                                        Coverages
                                      </TableCell>
                                      <TableCell className="font-bold p-6">
                                        Person Per Limit
                                      </TableCell>
                                      <TableCell className="font-bold p-6">
                                        Per Incident Limit
                                      </TableCell>
                                      <TableCell className="font-bold p-6">
                                        Deductible
                                      </TableCell>
                                      <TableCell className="font-bold p-6">
                                        Premium
                                      </TableCell>
                                      <TableCell className="font-bold p-6">
                                        Declined
                                      </TableCell>
                                    </TableRow>

                                    {trailer.coverage.map((coverage, index) => {
                                      return (
                                        <>
                                          <TableRow
                                            className="bg-table-row"
                                            sx={{ backgroundColor: "#ffffff" }}
                                          >
                                            <TableCell className="p-6">
                                              {coverage.name}
                                            </TableCell>
                                            <TableCell className="p-6">
                                              ${" "}
                                              {coverage.per_person_limit_cents /
                                                100}
                                            </TableCell>
                                            <TableCell className="p-6">
                                              ${" "}
                                              {coverage.per_incident_limit_cents /
                                                100}
                                            </TableCell>
                                            <TableCell className="p-6">
                                              ${" "}
                                              {formatCurrency(
                                                coverage.deductible_cents
                                              )}
                                            </TableCell>
                                            <TableCell className="p-6">
                                              ${" "}
                                              {formatCurrency(
                                                coverage.premium_cents
                                              )}
                                            </TableCell>
                                            <TableCell className="p-6">
                                              {coverage.is_declined}
                                            </TableCell>
                                          </TableRow>
                                        </>
                                      );
                                    })}
                                  </>
                                )}
                              </>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Box>
                  </>
                );
              })} */}

            {/* Motorcycle Table */}
            {/* {motorcyclePolicy.length > 0 &&
              motorcyclePolicy.map((cycle) => {
                return (
                  <>
                    <br />
                    <PolicyTable
                      name={cycle?.name}
                      policyNumber={cycle?.policyNumber}
                      premium={cycle?.premium}
                      effectiveDates={cycle?.effectiveDates}
                      status={cycle?.status}
                      canceled_date={cycle?.canceled_date}
                      dwellings={cycle?.dwellings}
                    />
                  </>
                );
              })} */}

            {/* Home Owners */}
            {/* {homeOwnerPolicy.length > 0 &&
              homeOwnerPolicy.map((home) => {
                return (
                  <>
                    <br />
                    <PolicyTable
                      name={home?.name}
                      policyNumber={home?.ownerNumber}
                      premium={home?.premium}
                      effectiveDates={home?.effectiveDates}
                      dwellings={home?.dwellings}
                      status={home?.status}
                      canceled_date={home?.canceled_date}
                    />
                  </>
                );
              })} */}

            {/* Umbrella policy table */}
            {/* {umbrellaPolicy.length > 0 &&
              umbrellaPolicy.map((umbrella) => {
                return (
                  <>
                    <br />
                    <PolicyTable
                      name={umbrella?.name}
                      policyNumber={umbrella?.number}
                      premium={umbrella?.premium}
                      effectiveDates={umbrella?.effectiveDates}
                      status={umbrella?.status}
                      canceled_date={umbrella?.canceled_date}
                    />
                  </>
                );
              })} */}

            {/* Driving Records Table */}

            {payload.driving_records.length > 0 && (
              <>
                <br />
                <Box>
                  <Table className="border">
                    <TableHead>
                      <TableRow
                        className="bg-table-head"
                        sx={{ backgroundColor: "#f2f2f2" }}
                      >
                        <TableCell className="font-bold p-6" colSpan={2}>
                          Driving Records
                        </TableCell>

                        <TableCell className="font-bold p-6">Type</TableCell>
                        <TableCell className="font-bold p-6">Driver</TableCell>
                        <TableCell className="font-bold p-6" colSpan={2}>
                          Fault
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payload.driving_records.map((records) => {
                        return (
                          <TableRow
                            sx={{
                              bgcolor: "#ffe9ec",
                            }}
                          >
                            <TableCell className="p-6" colSpan={2}>
                              {formatDateWithTime(
                                records.incident_date
                              ).substring(0, 10)}
                            </TableCell>
                            <TableCell className="p-6">
                              {records.incident_type}
                            </TableCell>
                            <TableCell className="p-6">
                              {payload?.drivers?.map((driver) => {
                                return driver.driver_id === records.driver_id
                                  ? driver.first_name + " " + driver.last_name
                                  : "";
                              }) || "N/A"}
                            </TableCell>
                            <TableCell className="p-6" colSpan={2}>
                              {records.is_at_fault}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
              </>
            )}

            {/* Claims Table */}
            {payload.claims.length > 0 && (
              <>
                <br />
                <Box>
                  <Table className="border">
                    <TableHead>
                      <TableRow
                      // className="bg-table-head"
                      // sx={{ backgroundColor: "#f2f2f2" }}
                      >
                        <TableCell className="font-bold p-6" colSpan={6}>
                          Claims
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
                      <TableCell className="font-bold p-6">Date</TableCell>
                      <TableCell className="font-bold p-6">Type</TableCell>
                      <TableCell className="font-bold p-6">Policy</TableCell>
                      <TableCell className="font-bold p-6">
                        Carrier ID
                      </TableCell>
                      <TableCell className="font-bold p-6">Payout</TableCell>
                      <TableCell className="font-bold p-6">Status</TableCell>
                    </TableRow>
                    {payload.claims.map((claim) => {
                      return (
                        <TableRow
                          className="bg-table-row"
                          sx={{
                            bgcolor: "#ffe9ec",
                          }}
                        >
                          <TableCell className="p-6">
                            {formatDateWithTime(claim.date_occurred).substring(
                              0,
                              10
                            )}
                          </TableCell>
                          <TableCell className="p-6">{claim.type}</TableCell>
                          <TableCell className="p-6">
                            {claim.policy_id}
                          </TableCell>
                          <TableCell className="p-6">
                            {claim.carrier_claim_identifier}
                          </TableCell>
                          <TableCell className="p-6">
                            {"$ " + formatCurrency(claim.payout_cents)}
                          </TableCell>
                          <TableCell className="p-6">{claim.status}</TableCell>
                        </TableRow>
                      );
                    })}
                  </Table>
                </Box>
              </>
            )}
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <AppButton
              buttonText="Print"
              clickHandler={() => {
                handlePrint();
              }}
              size="small"
              variant="contained"
              sx={{
                // flex: 1,
                mx: "auto",
                width: "30%",
                // my: 1,
                marginTop: "16px",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          </Box>
        </>
      )}
    </>
  );
};

export default ApiTableComponent;
